import { sendToVcars } from './vcarsEndpoint';

/** Una fila de la pestaña "Simulacion financiacion". */
export interface FinancingRequest {
  nombre: string;
  apellido: string;
  cuil: string;
  telefono: string;
  email: string;
  autoInteres: string;
  anticipo: string;
  cuotas: string;
  precioContado: string;
  // Para la pestaña "SCORE CREDIT"
  montoFinanciar: string;
  valorCuota: string;
  situacionLaboral: string;
  ingresosMensuales: string;
  antiguedad: string;
  cuentaBancaria: string;
  garante: string;
  permuta: string;
}

export async function submitFinancingRequest(request: FinancingRequest): Promise<void> {
  await sendToVcars('simulacion', { ...request, vehiculoInteres: request.autoInteres });
}
